import { render, staticRenderFns } from "./FormItemSpace.vue?vue&type=template&id=553a287b"
import script from "./FormItemSpace.vue?vue&type=script&lang=js"
export * from "./FormItemSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports